<mat-card class="mat-card mat-focus-indicator">
	<mat-card-title>
		<h2>Company Settings</h2>
	</mat-card-title>

	<mat-card-content *ngIf="organisationForm">
		<form [formGroup]="organisationForm">
			<div class="row">
				<div class="col-12 col-md-6">
					<div class="row">
						<mat-form-field class="col-12">
							<input type="text" [ngClass]="{ 'is-invalid': submitted && f.name.errors }" matInput
								placeholder="Company Name" formControlName="name" autocomplete="organization">
							<div *ngIf="submitted && f.name.errors" class="invalid-feedback">
								<div *ngIf="f.name.errors.required">
									Company Name is required.
								</div>
							</div>
						</mat-form-field>
						<div class="text-danger"
							*ngIf="f.name.errors && (f.name.dirty || f.name.touched) ">
							<div *ngIf="f.name.errors.required">
								*Please enter a company name
							</div>
						</div>

						<mat-form-field class="col-12">
							<input type="text" [ngClass]="{ 'is-invalid': submitted && f.billing_email.errors }" matInput
								placeholder="Billing Email" formControlName="billing_email" autocomplete="organization">
							<div *ngIf="submitted && f.billing_email.errors" class="invalid-feedback">
								<div *ngIf="f.billing_email.errors.required">
									Billing email is required.
								</div>

								<div *ngIf="f.name.errors.email">
									*Please enter a valid email
								</div>
							</div>
						</mat-form-field>
					</div>

					<div class="row">
						<div class="col-12" tourAnchor="settings.company.logo">
                            <h3>Logo</h3>
							<div class="dropzone" fileDragDrop (filesChangeEmiter)="onDragDropFileChange($event)" *ngIf="!f.logo.value && imagePreview == null">
								<div class="text-wrapper">
									<div class="centered">
										<input type="file" name="file" id="file" (change)="onFileChange($event)">
                                        <label for="file">
                                            <p>Drop your file here</p>
                                            <small class="d-block form-text">or</small>
                                            <button mat-stroked-button color="primary" class="mt-2">Browse files</button>
                                        </label>
									</div>
								</div>
							</div>
						</div>

						<!-- <h3 mat-subheader>Files</h3> -->
						<div class="fileItem" *ngIf="imagePreview" (click)="removeFile()">
							<img [src]="imagePreview" style="width: -webkit-fill-available;">
							<i class="fa-6x fileItemIcon"></i>
						</div>

					</div>
				</div>

				<!-- <div class="col-12 col-md-6">
					<div class="row">
						<div *ngFor="let system_owner of system_owners.controls; let i = index"
							[formGroup]="system_owner">
							<mat-form-field class="col-12">
								<mat-label>System Owner</mat-label>
								<mat-select name="systemOwner" formControlName="id">
									<mat-option *ngFor="let user of systemUsers" [value]="user.id">
										{{user.name}}
									</mat-option>
								</mat-select>
								<button matSuffix mat-button aria-label="remove" [disabled]="system_owner.disabled" (click)="removeSystemOwner(i)">
									Remove
								</button>
							</mat-form-field>
						</div>
						<div class="text-danger" *ngIf="f.system_owners.errors">
							<div *ngIf="f.system_owners.errors.required" padding>
								*Please select atleast 1 system owner
							</div>
						</div>
					</div>

					<mat-form-field class="col-12">
						<mat-label>System Owner</mat-label>
						<mat-select name="addSystemOwner" formControlName="add_system_owner">
							<mat-option *ngFor="let user of systemUsers" [value]="user.id">
								{{user.name}}
							</mat-option>
						</mat-select>
						<button matSuffix mat-raised-button color="primary" aria-label="addSystemOwner"
							(click)="addSystemOwner(true)">
							Add
						</button>
					</mat-form-field>
				</div> -->
			</div>

			<div class="row">
				<div class="col-12 col-md-6">
					<form formGroupName="trading_address" tourAnchor="settings.company.addresses">
						<div class="row">
							<h3 class="col-12">Trading Address</h3>
						</div>

						<mat-form-field>
							<mat-label>Address 1</mat-label>
							<input matInput type="text" formControlName="address_line_1" required>
						</mat-form-field>
						<div class="text-danger"
							*ngIf="organisationForm.get('trading_address.address_line_1').errors && (organisationForm.get('trading_address.address_line_1').dirty || organisationForm.get('trading_address.address_line_1').touched) ">
							<div *ngIf="organisationForm.get('trading_address.address_line_1').errors.required" padding>
								*Please enter Address 1.
							</div>
						</div>

						<mat-form-field>
							<mat-label>Address 2</mat-label>
							<input matInput type="text" formControlName="address_line_2">
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('trading_address.address_line_2').errors && (organisationForm.get('trading_address.address_line_2').dirty || organisationForm.get('trading_address.address_line_2').touched) ">
							<div *ngIf="organisationForm.get('trading_address.address_line_2').errors.required" padding>
								*Please enter Address 2.
							</div>
						</div> -->

						<mat-form-field>
							<mat-label>Address 3</mat-label>
							<input matInput type="text" formControlName="address_line_3">
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('trading_address.address_line_3').errors && (organisationForm.get('trading_address.address_line_3').dirty || organisationForm.get('trading_address.address_line_3').touched) ">
							<div *ngIf="organisationForm.get('trading_address.address_line_3').errors.required" padding>
								*Please enter Address 3.
							</div>
						</div> -->

						<mat-form-field>
							<mat-label>Postcode</mat-label>
							<input matInput type="text" formControlName="postcode"
								(input)="forceUppercaseConditionally('trading_address', 'postcode', $event);"
								required />
						</mat-form-field>
						<div class="text-danger"
							*ngIf="organisationForm.get('trading_address.postcode').errors && (organisationForm.get('trading_address.postcode').dirty || organisationForm.get('trading_address.postcode').touched) ">
							<div *ngIf="organisationForm.get('trading_address.postcode').errors.required" padding>
								*Please enter postcode.
							</div>
						</div>

						<mat-form-field>
							<mat-label>locality / City</mat-label>
							<input matInput type="text" formControlName="locality">
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('trading_address.locality').errors && (organisationForm.get('trading_address.locality').dirty || organisationForm.get('trading_address.locality').touched) ">
							<div *ngIf="organisationForm.get('trading_address.locality').errors.required" padding>
								*Please enter locality / city.
							</div>
						</div> -->

						<mat-form-field>
							<mat-label>County</mat-label>
							<input matInput type="text" formControlName="county">
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('trading_address.county').errors && (organisationForm.get('trading_address.county').dirty || organisationForm.get('trading_address.county').touched) ">
							<div *ngIf="organisationForm.get('trading_address.county').errors.required" padding>
								*Please enter County.
							</div>
						</div> -->

						<mat-form-field>
							<mat-label>Country</mat-label>
							<mat-select formControlName="country" required>
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search for Countries" noEntriesFoundLabel="No matching country found" (keyup)="searchTradingCountries($event)"></ngx-mat-select-search>
                                </mat-option>
								<mat-option *ngFor="let country of tradingCountrySearch" [value]="country"><img style="max-width: 20px; margin-right: 5px;" [src]="country.flags.png"> {{country.name.common | titlecase}}</mat-option>
							</mat-select>
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('trading_address.country').errors && (organisationForm.get('trading_address.country').dirty || organisationForm.get('trading_address.country').touched) ">
							<div *ngIf="organisationForm.get('trading_address.country').errors.required" padding>
								*Please enter Country.
							</div>
						</div> -->
					</form>
				</div>

				<div class="col-12 col-md-6">
					<form formGroupName="billing_address">
						<div class="row">
							<h3 class="col-12 col-md-8">Billing Address</h3>
							<mat-checkbox class="col-12 col-md-4 text-right" color="primary"
								(change)="sameAsTradingAddress($event)">Same as trading
								address?</mat-checkbox>
						</div>

						<mat-form-field>
							<mat-label>Address 1</mat-label>
							<input matInput type="text" formControlName="address_line_1" required>
						</mat-form-field>
						<div class="text-danger"
							*ngIf="organisationForm.get('billing_address.address_line_1').errors && (organisationForm.get('billing_address.address_line_1').dirty || organisationForm.get('billing_address.address_line_1').touched) ">
							<div *ngIf="organisationForm.get('billing_address.address_line_1').errors.required" padding>
								*Please enter Address 1.
							</div>
						</div>

						<mat-form-field>
							<mat-label>Address 2</mat-label>
							<input matInput type="text" formControlName="address_line_2">
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('billing_address.address_line_2').errors && (organisationForm.get('billing_address.address_line_2').dirty || organisationForm.get('billing_address.address_line_2').touched) ">
							<div *ngIf="organisationForm.get('billing_address.address_line_2').errors.required" padding>
								*Please enter Address 2.
							</div>
						</div> -->

						<mat-form-field>
							<mat-label>Address 3</mat-label>
							<input matInput type="text" formControlName="address_line_3">
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('billing_address.address_line_3').errors && (organisationForm.get('billing_address.address_line_3').dirty || organisationForm.get('billing_address.address_line_3').touched) ">
							<div *ngIf="organisationForm.get('billing_address.address_line_3').errors.required" padding>
								*Please enter Address 3.
							</div>
						</div> -->

						<mat-form-field>
							<mat-label>Postcode</mat-label>
							<input matInput type="text" formControlName="postcode"
								(input)="forceUppercaseConditionally('billing_address', 'postcode', $event);"
								required />
						</mat-form-field>
						<div class="text-danger"
							*ngIf="organisationForm.get('billing_address.postcode').errors && (organisationForm.get('billing_address.postcode').dirty || organisationForm.get('billing_address.postcode').touched) ">
							<div *ngIf="organisationForm.get('billing_address.postcode').errors.required" padding>
								*Please enter postcode.
							</div>
						</div>

						<mat-form-field>
							<mat-label>locality / City</mat-label>
							<input matInput type="text" formControlName="locality">
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('billing_address.locality').errors && (organisationForm.get('billing_address.locality').dirty || organisationForm.get('billing_address.locality').touched) ">
							<div *ngIf="organisationForm.get('billing_address.locality').errors.required" padding>
								*Please enter locality / city.
							</div>
						</div> -->

						<mat-form-field>
							<mat-label>County</mat-label>
							<input matInput type="text" formControlName="county">
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('billing_address.county').errors && (organisationForm.get('billing_address.county').dirty || organisationForm.get('billing_address.county').touched) ">
							<div *ngIf="organisationForm.get('billing_address.county').errors.required" padding>
								*Please enter County.
							</div>
						</div> -->

						<mat-form-field>
							<mat-label>Country</mat-label>
							<mat-select formControlName="country" required>
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search for Countries" noEntriesFoundLabel="No matching country found" (keyup)="searchBillingCountries($event)"></ngx-mat-select-search>
                                </mat-option>
								<mat-option *ngFor="let country of billingCountrySearch" [value]="country"><img style="max-width: 20px; margin-right: 5px;" [src]="country.flags.png"> {{country.name.common | titlecase}}</mat-option>
							</mat-select>
						</mat-form-field>
						<!-- <div class="text-danger"
							*ngIf="organisationForm.get('billing_address.country').errors && (organisationForm.get('billing_address.country').dirty || organisationForm.get('billing_address.country').touched) ">
							<div *ngIf="organisationForm.get('billing_address.country').errors.required" padding>
								*Please enter Country.
							</div>
						</div> -->
					</form>
				</div>
			</div>
		</form>

		<div class="row">
			<button mat-raised-button color="primary" (click)="submitForm()">Submit</button>
		</div>
	</mat-card-content>
</mat-card>
